import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div style={{ padding: 40, color: "#4a0000" }}>Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
